import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MatchDiff } from "@shared/models/common";
import { diff_match_patch } from '@shared/diff_match_patch_uncompressed.js';


@Component({
    selector: 'char-based-phrase-diffs',
    templateUrl: './char-based-phrase-diffs.component.html',
    styleUrls: ['./char-based-phrase-diffs.component.scss'],
    standalone: false
})
export class CharBasedPhraseDiffComponent implements OnChanges {

    @Input() workingPhrase: string;

    @Input() matched: string;
    phraseDiffs: MatchDiff[] = [];

private diffTypeMapping = new Map<number, string>([
    [-1, 'MISSING'],
    [1, 'EXTRA'],
    [0, 'MATCH']
  ]);
    
  ngOnChanges(changes: SimpleChanges): void {

        this.phraseDiffs = this.getCharBasedPhraseDiffs();  
    }
  getCharBasedPhraseDiffs(): MatchDiff[] {

    return new diff_match_patch().diff_main(this.workingPhrase, this.matched).map(part => {
      const matchDiff = new MatchDiff();
      matchDiff.text = part[1];
      matchDiff.diffType = this.diffTypeMapping.get(part[0]);
      return matchDiff;
    });
  }


}